import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

const CATEGORY_LABEL = {
  tshirt: "TEE",
  hoodie: "HOODIE",
  hat: "HAT",
  beanie: "BEANIE",
  sticker: "STICKER",
  patch: "PATCH",
  coin: "COIN",
  tumbler: "TUMBLER",
};

export default function ProductCard({ product, divisionAccent }) {
  const accent = divisionAccent || product.accent || "#D4AF37";
  const isLegacy = product.is_award_only;
  const image = (product.images && product.images[0]) || product.image || "";

  return (
    <Link
      data-testid={`product-card-${product.slug}`}
      to={`/product/${product.slug}`}
      className="group block bg-[#11141C] border border-[#1F2330] hover:border-[var(--hover)] transition-all duration-300 relative overflow-hidden shadow-[0_14px_40px_rgba(0,0,0,0.32)] hover:shadow-[0_24px_60px_rgba(0,0,0,0.48)] hover:-translate-y-1"
      style={{ "--hover": accent }}
    >
      <div className="relative aspect-[4/5] overflow-hidden brushed">
        <div
          className="absolute inset-0 opacity-60"
          style={{
            background: `radial-gradient(circle at 50% 40%, ${accent}33 0%, transparent 65%)`,
          }}
        />
        <img
          src={image}
          alt={product.name}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(255,255,255,0.05)_0%,transparent_18%,rgba(0,0,0,0.05)_68%,rgba(0,0,0,0.7)_100%)]" />
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#06080C] to-transparent" />
        {product.badge && (
          <div
            className="absolute top-3 left-3 text-[9px] font-mono uppercase tracking-[0.25em] px-2 py-1 border"
            style={
              isLegacy
                ? { background: "#D4AF37", color: "#000", borderColor: "#D4AF37" }
                : { background: "#06080C", color: accent, borderColor: accent }
            }
          >
            {product.badge}
          </div>
        )}
        <div className="absolute top-3 right-3 border border-[#2A3040] bg-[#06080C]/80 text-[9px] font-mono uppercase tracking-[0.25em] px-2 py-1 text-[#A0A6B5]">
          {CATEGORY_LABEL[product.category] || product.category}
        </div>
        {isLegacy && (
          <div className="absolute inset-0 bg-[#06080C]/60 flex items-end justify-center pb-4 opacity-100 group-hover:opacity-0 transition-opacity">
            <div className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-[0.3em] text-[#D4AF37] border border-[#D4AF37]/60 px-3 py-1 bg-[#06080C]/80">
              <Lock className="w-3 h-3" /> Issued. Not Sold.
            </div>
          </div>
        )}
      </div>

      <div className="p-4 border-t border-[#1F2330] bg-[linear-gradient(180deg,rgba(255,255,255,0.03),transparent)]">
        <div
          className="text-[10px] font-mono uppercase tracking-[0.25em] mb-1"
          style={{ color: accent }}
        >
          {product.division === "legacy" ? "Legacy Division" : "Core Division"}
        </div>
        <div className="font-display text-base uppercase tracking-[0.05em] leading-tight mb-2 group-hover:text-[var(--hover)] transition-colors drop-shadow-[0_1px_0_rgba(0,0,0,0.55)]">
          {product.name}
        </div>
        <div className="text-[11px] text-[#A0A6B5] mb-3 line-clamp-1">{product.short}</div>
        <div className={`flex items-center ${isLegacy ? "justify-between" : "justify-end"}`}>
          {isLegacy && (
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]">
              Awarded
            </span>
          )}
          <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-[#A0A6B5] group-hover:text-white">
            View →
          </span>
        </div>
      </div>
    </Link>
  );
}
